export default __webpack_public_path__ + "static/media/websiteBackground01.61ab48d0.jpeg";